<template>
  <div></div>
</template>

<script>
import { redirectToTrackerURLIfNeeded } from '@/utils/adjust_redirector'

export default {
  created() {
    location.href = '/'
  }
}
</script>
